import { api } from './client';

export interface PushPublicKey {
  enabled: boolean;
  publicKey: string;
}

export const pushApi = {
  publicKey: () => api.get<PushPublicKey>('/me/push/public-key'),
  subscribe: (sub: { endpoint: string; p256dh: string; auth: string }) =>
    api.post<void>('/me/push/subscribe', sub),
  unsubscribe: (endpoint: string) =>
    api.post<void>('/me/push/unsubscribe', { endpoint }),
};
